import { EnvelopeSimple, PaperPlaneTilt, ShieldCheck } from "@phosphor-icons/react";
import NewsletterForm from "@/components/NewsletterForm";

/**
 * Home-page section promoting the monthly briefing.
 */
export default function NewsletterSection() {
  return (
    <section
      data-testid="newsletter-section"
      className="bg-gradient-to-br from-emerald-950/40 via-stone-950 to-stone-950 border-y border-emerald-900/30 py-16 sm:py-20"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3 space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-600/10 border border-emerald-700/30">
              <PaperPlaneTilt size={14} weight="duotone" className="text-emerald-400" />
              <span className="text-[10px] uppercase tracking-[0.18em] text-emerald-300 font-heading font-semibold">
                Monthly Briefing
              </span>
            </div>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white leading-tight">
              Get the Conexus Foundation monthly briefing
            </h2>
            <p className="text-sm text-stone-400 font-body max-w-xl">
              A concise monthly digest covering new satellite datasets, released whitepapers,
              carbon-project highlights, and platform updates. One email a month, no spam.
            </p>
            <ul className="space-y-2 text-xs text-stone-400 pt-2">
              <li className="flex items-center gap-2">
                <ShieldCheck size={14} weight="duotone" className="text-emerald-400" />
                Unsubscribe with one click at any time
              </li>
              <li className="flex items-center gap-2">
                <EnvelopeSimple size={14} weight="duotone" className="text-emerald-400" />
                Straight to your inbox — no third-party trackers
              </li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <NewsletterForm />
          </div>
        </div>
      </div>
    </section>
  );
}
